
export function RemoveItem(itemData)
{
    return(
        { 
            type: 'remove_cart',
            payload: itemData,
        }
    )
}